import { createContext } from "react";
import { MessageChannelManager } from "@yujacorp/verity-live";
import { PopInSessionsQueryParams } from "./store/hooks";

type ContextContents = {
	messageChannelManager: MessageChannelManager<PopInSessionsQueryParams>;
};
export const PopInContext = createContext<ContextContents>({} as ContextContents);
